import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mic",
  "use": "icon-mic-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-mic\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path d=\"M22 1.833A9.167 9.167 0 0 1 31.167 11v7.333a9.167 9.167 0 0 1-18.334 0V11A9.167 9.167 0 0 1 22 1.833ZM5.6 20.167h3.695a12.837 12.837 0 0 0 25.406 0h3.696a16.507 16.507 0 0 1-14.564 14.566v7.434h-3.666v-7.434A16.507 16.507 0 0 1 5.6 20.166Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol